import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../../custom/custom-button/CustomButton";
import styles from "../common.module.scss";
import { User } from "../../../services";
import CircularProgress from "../../custom/circular-progress/CircularProgress";

const EMPTY_CODE = ["", "", "", ""];

const EnterCodeComponent = ({ data, updateStep, setData }) => {
  const [code, setCode] = useState(EMPTY_CODE);
  const inputs = useRef([]);
  const isResendPending = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isResendingCode, setIsResendingCode] = useState(false);

  const isCodeValid = code.every(Boolean);

  const handleChange = (value, index) => {
    if (value === "") {
      setCode((currentCode) =>
        currentCode.map((digit, digitIndex) => (digitIndex === index ? "" : digit)),
      );
      return;
    }

    if (/^\d$/.test(value)) {
      setCode((currentCode) =>
        currentCode.map((digit, digitIndex) => (digitIndex === index ? value : digit)),
      );
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index]) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const digits = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4).split("");
    if (digits.length === 0) return;

    setCode(EMPTY_CODE.map((_, index) => digits[index] || ""));
    inputs.current[Math.min(digits.length, 3)]?.focus();
  };

  const nextStep = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await User.checkСodePassword(code.join(""));
      if (response.data.isActualCode === true) {
        updateStep(3);
        setData({ ...data, code: code.join("") });
      }
    } catch (error) {
      toast.error("Введен неправильный код подтверждения");
    } finally {
      setIsLoading(false);
    }
  };

  const resendCode = async () => {
    if (isResendPending.current) return;

    if (!data?.userEmail) {
      toast.error("Не удалось определить e-mail для отправки кода");
      return;
    }

    isResendPending.current = true;
    setIsResendingCode(true);
    try {
      await User.forgotPassword(data.userEmail);
      toast.info("Код для восстановление пароля отправлен на вашу почту");
    } catch (error) {
      toast.error(error?.message || "Ошибка при отправки письма");
    } finally {
      isResendPending.current = false;
      setIsResendingCode(false);
    }
  };

  return (
    <>
      <div className={styles.card_form}>
        <div className={styles.codeInputs}>
          {code.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputs.current[index] = el)}
              value={digit}
              type="text"
              inputMode="numeric"
              maxLength={1}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              className={styles.codeInput}
              placeholder="0"
            />
          ))}

          <div style={{ display: code.every((digit) => digit === "") ? "none" : "block" }}>
            <CircularProgress
              size={24}
              strokeWidth={2}
              stages={4}
              currentStage={code.filter(Boolean).length}
              color="#2857FC"
            />
          </div>
        </div>
      </div>

      <div className={styles.btns}>
        <CustomButton
          isFall
          isDisabled={!isCodeValid}
          text="Восстановить"
          onClick={nextStep}
          isLoading={isLoading}
        />
        <CustomButton
          isFall
          text="Переотправить код"
          isUnderline={true}
          onClick={resendCode}
          isLoading={isResendingCode}
          isDisabled={isResendingCode}
        />
      </div>
    </>
  );
};

export default EnterCodeComponent;
